import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { settings, useSetting } from '../../../settings';
import { ProjectTimeDisplayMode } from '../ProjectTimeDisplayMode';

export const useProjectHoursMode = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setting = useSetting(settings.projectTimeDisplayMode());

  const displayModeParam = searchParams.get(
    'displayMode'
  ) as ProjectTimeDisplayMode;

  const value = displayModeParam || setting.value;

  const set = useCallback(
    (value: ProjectTimeDisplayMode) => {
      setting.set(value);
      setSearchParams((prev) => {
        prev.delete('displayMode');
        return prev;
      });
    },
    [setSearchParams, setting]
  );

  return [value, set] as const;
};
